import { useState, useEffect, useRef } from "react";
import CarouselArrow from "../../CarouselArrow/CarouselArrow";
import { getImageUrl, getVideoEmbedUrl } from "../../../utils/media";
import "./style.css";

const AUTOPLAY_INTERVAL = 15000;

export default function Slideshow({ slides: slidesProp, fallbackSlides = [] }) {
  const slides = slidesProp?.length ? slidesProp : fallbackSlides;
  const [currentSlide, setCurrentSlide] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (currentSlide >= slides.length) setCurrentSlide(0);
  }, [slides.length, currentSlide]);

  useEffect(() => {
    if (slides.length <= 1) return undefined;
    intervalRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, AUTOPLAY_INTERVAL);
    return () => clearInterval(intervalRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slides.length, currentSlide]);

  if (slides.length === 0) {
    return (
      <section className="nucleo-slideshow nucleo-slideshow--vazio">
        <p>Em breve, fotos deste núcleo serão exibidas aqui.</p>
      </section>
    );
  }

  const goTo = (index) => setCurrentSlide(index);
  const prev = () => setCurrentSlide((i) => (i - 1 + slides.length) % slides.length);
  const next = () => setCurrentSlide((i) => (i + 1) % slides.length);

  return (
    <section className="nucleo-slideshow" aria-label="Galeria de fotos do núcleo">
      <div className="nucleo-slideshow__track">
        {slides.map((slide, index) => {
          const imageUrl = getImageUrl(slide.imageUrl ?? slide);
          const videoUrl = getVideoEmbedUrl(imageUrl);
          return (
            <div
              key={slide._id || index}
              className={`nucleo-slideshow__slide ${index === currentSlide ? "nucleo-slideshow__slide--active" : ""}`}
              style={
                videoUrl
                  ? undefined
                  : {
                      backgroundImage: imageUrl ? `url(${imageUrl})` : undefined,
                      ...(slide.focalPoint
                        ? { backgroundPosition: slide.focalPoint }
                        : {}),
                    }
              }
              aria-hidden={index !== currentSlide}
            >
              {videoUrl && index === currentSlide && (
                <iframe
                  className="nucleo-slideshow__video"
                  src={videoUrl}
                  title={slide.alt || `Vídeo do núcleo ${index + 1}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              )}
            </div>
          );
        })}
      </div>

      {slides.length > 0 && (
        <>
          <CarouselArrow
            direction="prev"
            className="nucleo-slideshow__seta nucleo-slideshow__seta--prev"
            onClick={prev}
            ariaLabel="Foto anterior"
          />
          <CarouselArrow
            direction="next"
            className="nucleo-slideshow__seta nucleo-slideshow__seta--next"
            onClick={next}
            ariaLabel="Próxima foto"
          />

          <div className="nucleo-slideshow__dots">
            {slides.map((slide, index) => (
              <button
                key={slide._id || index}
                type="button"
                className={`nucleo-slideshow__dot ${index === currentSlide ? "nucleo-slideshow__dot--active" : ""}`}
                onClick={() => goTo(index)}
                aria-label={`Ir para foto ${index + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </section>
  );
}
